'use es6';

export const APPLICATION_SET_ACTIVE_EDITOR = 'APPLICATION_SET_ACTIVE_EDITOR';
export const APPLICATION_TOGGLE_FINDER = 'APPLICATION_TOGGLE_FINDER';
export const APPLICATION_SET_IS_KEYBOARD_SHORTCUTS_LISTING_SHOWING = 'APPLICATION_SET_IS_KEYBOARD_SHORTCUTS_LISTING_SHOWING';
export const APPLICATION_HIDE_GLOBAL_CONTENT_MESSAGE = 'APPLICATION_HIDE_GLOBAL_CONTENT_MESSAGE';
export const APPLICATION_SHOW_GLOBAL_CONTENT_MESSAGE = 'APPLICATION_SHOW_GLOBAL_CONTENT_MESSAGE';
export const APPLICATION_SET_FINDER_WIDTH = 'APPLICATION_SET_FINDER_WIDTH';
export const APPLICATION_SET_ALWAYS_SHOW_FINDER_ON_START = 'APPLICATION_SET_ALWAYS_SHOW_FINDER_ON_START';
export const APPLICATION_UPDATE_PREVIEWER = 'APPLICATION_UPDATE_PREVIEWER';
export const APPLICATION_ADD_PINNED_TAB = 'APPLICATION_ADD_PINNED_TAB';
export const APPLICATION_REMOVE_PINNED_TAB = 'APPLICATION_REMOVE_PINNED_TAB';
export const APPLICATION_EDITOR_LOADED = 'APPLICATION_EDITOR_LOADED';
export const APPLICATION_DISMISS_RESPONSIVE_IMAGE_WARNING = 'APPLICATION_DISMISS_RESPONSIVE_IMAGE_WARNING';
export const APPLICATION_DISMISS_SHOW_LOADING_WARNING = 'APPLICATION_DISMISS_SHOW_LOADING_WARNING';
export const APPLICATION_DISMISS_ICON_SET_WARNING = 'APPLICATION_DISMISS_ICON_SET_WARNING';
export const APPLICATION_DISMISS_ADVANCED_REL_WARNING = 'APPLICATION_DISMISS_ADVANCED_REL_WARNING';
export const APPLICATION_DISMISS_ADVANCED_VIDEO_OPTIONS_WARNING = 'APPLICATION_DISMISS_ADVANCED_VIDEO_OPTIONS_WARNING';
export const APPLICATION_SETTINGS_USER_SAVE = 'APPLICATION_SETTINGS_USER_SAVE';
export const APPLICATION_SETTINGS_USER_JSLINTER_TOGGLE = 'APPLICATION_SETTINGS_USER_JSLINTER_TOGGLE';
export const APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_UPDATE = 'APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_UPDATE';
export const APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_ERROR = 'APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_CONFIG_ERROR';
export const APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_DEMO_ERRORS = 'APPLICATION_SETTINGS_USER_JSLINTER_ESLINT_DEMO_ERRORS';
export const FETCH_ATTRIBUTES_META = 'FETCH_ATTRIBUTES_META';
export const RECEIVE_ATTRIBUTES_META = 'RECEIVE_ATTRIBUTES_META';
export const FLASH = 'FLASH';
export const FLASH_REMOVE = 'FLASH_REMOVE';
export const SHARED_DND_UPDATE_CONTEXT_MONITOR = 'SHARED_DND_UPDATE_CONTEXT_MONITOR';
export const TEMPLATE_CONSTANTS_FETCH = 'TEMPLATE_CONSTANTS_FETCH';
export const UNIFIED_LAYOUT_FETCH = 'UNIFIED_LAYOUT_FETCH';
export const LAYOUT_CREATE_FROM_FILE = 'LAYOUT_CREATE_FROM_FILE';
export const LAYOUT_DELETE = 'LAYOUT_DELETE';
export const LAYOUT_WIDGET_SPLIT = 'LAYOUT_WIDGET_SPLIT';
export const LAYOUT_BUFFER_SAVE = 'LAYOUT_BUFFER_SAVE';
export const LAYOUT_PUBLISH = 'LAYOUT_PUBLISH';
export const LAYOUT_PROPERTIES_EDIT = 'LAYOUT_PROPERTIES_EDIT';
export const LAYOUT_MOVE_RENAME = 'LAYOUT_MOVE_RENAME';
export const LAYOUT_REVERT = 'LAYOUT_REVERT';
export const LAYOUT_DISCARD_BUFFER = 'LAYOUT_DISCARD_BUFFER';
export const LAYOUT_TOGGLE_EMAIL_TYPE = 'LAYOUT_TOGGLE_EMAIL_TYPE';
export const LAYOUT_CLEAR_UNDO_HISTORY = 'LAYOUT_CLEAR_UNDO_HISTORY';
export const LAYOUT_RENAME = 'LAYOUT_RENAME';
export const LAYOUT_UPDATE_FOLDER = 'LAYOUT_UPDATE_FOLDER';
export const LAYOUT_TOGGLE_IS_AVAILABLE_FOR_NEW_CONTENT = 'LAYOUT_TOGGLE_IS_AVAILABLE_FOR_NEW_CONTENT';
export const LAYOUT_OPTIMISTIC_MUTATION_MODAL_OPEN = 'LAYOUT_OPTIMISTIC_MUTATION_MODAL_OPEN';
export const LAYOUT_OPTIMISTIC_MUTATION_MODAL_CANCEL = 'LAYOUT_OPTIMISTIC_MUTATION_MODAL_CANCEL';
export const LAYOUT_OPTIMISTIC_MUTATION_MODAL_CONFIRM = 'LAYOUT_OPTIMISTIC_MUTATION_MODAL_CONFIRM';
export const LAYOUT_OPTIMISTIC_MUTATION_MODAL_VIEW_DEPENDENCY = 'LAYOUT_OPTIMISTIC_MUTATION_MODAL_VIEW_DEPENDENCY';
export const LAYOUT_OPTIMISTIC_MUTATION_MODAL_NAVIGATE_DEPENDENCY = 'LAYOUT_OPTIMISTIC_MUTATION_MODAL_NAVIGATE_DEPENDENCY';
export const STYLESHEETS_FETCH = 'STYLESHEETS_FETCH';
export const JAVASCRIPTS_FETCH = 'JAVASCRIPTS_FETCH';
export const GRAPHQL_FILES_FETCH = 'GRAPHQL_FILES_FETCH';
export const CUSTOM_WIDGET_BUFFER_DELETE = 'CUSTOM_WIDGET_BUFFER_DELETE';
export const CUSTOM_WIDGET_BUFFER_DISCARD = 'CUSTOM_WIDGET_BUFFER_DISCARD';
export const CUSTOM_WIDGET_BUFFER_FETCH = 'CUSTOM_WIDGET_BUFFER_FETCH';
export const CUSTOM_WIDGET_BUFFER_FETCH_BY_PATH = 'CUSTOM_WIDGET_BUFFER_FETCH_BY_PATH';
export const CUSTOM_WIDGET_BUFFER_PUBLISH = 'CUSTOM_WIDGET_BUFFER_PUBLISH';
export const CUSTOM_WIDGET_BUFFER_SAVE = 'CUSTOM_WIDGET_BUFFER_SAVE';
export const CUSTOM_WIDGET_BUFFER_SAVE_BY_PATH = 'CUSTOM_WIDGET_BUFFER_SAVE_BY_PATH';
export const CUSTOM_WIDGET_SAVE_BY_PATH = 'CUSTOM_WIDGET_SAVE_BY_PATH';
export const CUSTOM_WIDGET_SAVE_BY_PATH_REQUEST = 'CUSTOM_WIDGET_SAVE_BY_PATH_REQUEST';
export const CUSTOM_WIDGET_CREATE = 'CUSTOM_WIDGET_CREATE';
export const CUSTOM_WIDGET_CREATE_FROM_FILE = 'CUSTOM_WIDGET_CREATE_FROM_FILE';
export const CUSTOM_WIDGET_FIELD_CREATE = 'CUSTOM_WIDGET_FIELD_CREATE';
export const CUSTOM_WIDGET_FIELD_CREATE_GROUP = 'CUSTOM_WIDGET_FIELD_CREATE_GROUP';
export const CUSTOM_WIDGET_FIELD_CLONE = 'CUSTOM_WIDGET_FIELD_CLONE';
export const CUSTOM_WIDGET_FIELD_DELETE = 'CUSTOM_WIDGET_FIELD_DELETE';
export const CUSTOM_WIDGET_FIELD_EDIT = 'CUSTOM_WIDGET_FIELD_EDIT';
export const CUSTOM_WIDGET_FIELD_MOVE = 'CUSTOM_WIDGET_FIELD_MOVE';
export const CUSTOM_WIDGET_REVERT = 'CUSTOM_WIDGET_REVERT';
export const CUSTOM_WIDGET_SOURCE_UPDATE = 'CUSTOM_WIDGET_SOURCE_UPDATE';
export const CUSTOM_WIDGET_BUFFER_VALIDATE = 'CUSTOM_WIDGET_BUFFER_VALIDATE';
export const CUSTOM_WIDGET_BUFFER_UPGRADE = 'CUSTOM_WIDGET_BUFFER_UPGRADE';
export const CUSTOM_WIDGET_BUFFER_FORCE_UPGRADE = 'CUSTOM_WIDGET_BUFFER_FORCE_UPGRADE';
export const CUSTOM_WIDGET_BUFFER_ADD_ASSET = 'CUSTOM_WIDGET_BUFFER_ADD_ASSET';
export const CUSTOM_WIDGET_BUFFER_UPDATE = 'CUSTOM_WIDGET_BUFFER_UPDATE';
export const CUSTOM_WIDGET_GLOBAL_CONTENT_EDIT = 'CUSTOM_WIDGET_GLOBAL_CONTENT_EDIT';
export const CUSTOM_WIDGET_BUFFER_TRANSLATIONS_OPT_IN = 'CUSTOM_WIDGET_BUFFER_TRANSLATIONS_OPT_IN';
export const CUSTOM_WIDGET_BUFFER_ADD_LANGUAGE = 'CUSTOM_WIDGET_BUFFER_ADD_LANGUAGE';
export const CUSTOM_WIDGET_BUFFER_DELETE_LANGUAGE = 'CUSTOM_WIDGET_BUFFER_DELETE_LANGUAGE';
export const CUSTOM_WIDGET_BUFFER_UPDATE_LANGUAGE = 'CUSTOM_WIDGET_BUFFER_UPDATE_LANGUAGE';
export const CUSTOM_WIDGET_BUFFER_CHANGE_SOURCE_LANGUAGE = 'CUSTOM_WIDGET_BUFFER_CHANGE_SOURCE_LANGUAGE';
export const CUSTOM_WIDGET_BUFFER_UPDATE_MESSAGES = 'CUSTOM_WIDGET_BUFFER_UPDATE_MESSAGES';
export const CUSTOM_WIDGET_BUFFER_UPDATE_TRANSLATION = 'CUSTOM_WIDGET_BUFFER_UPDATE_TRANSLATION';
export const CUSTOM_WIDGET_BUFFER_REPLACE_TRANSLATION = 'CUSTOM_WIDGET_BUFFER_REPLACE_TRANSLATION';
export const CUSTOM_WIDGET_EDITOR_OPTIONS_SELECT_SMART_RULE = 'CUSTOM_WIDGET_EDITOR_OPTIONS_SELECT_SMART_RULE';
export const CUSTOM_WIDGET_BUFFER_ADD_SMART_RULE = 'CUSTOM_WIDGET_BUFFER_ADD_SMART_RULE';
export const CUSTOM_WIDGET_BUFFER_REMOVE_SMART_RULE = 'CUSTOM_WIDGET_BUFFER_REMOVE_SMART_RULE';
export const CUSTOM_WIDGET_BUFFER_REMOVE_SMART_RULES = 'CUSTOM_WIDGET_BUFFER_REMOVE_SMART_RULES';
export const CUSTOM_WIDGET_BUFFER_EDIT_SMART_RULE = 'CUSTOM_WIDGET_BUFFER_EDIT_SMART_RULE';
export const CUSTOM_WIDGET_BUFFER_EDIT_SMART_RULES_ORDER = 'CUSTOM_WIDGET_BUFFER_EDIT_SMART_RULES_ORDER';
export const CUSTOM_WIDGET_BUFFER_MAKE_SMART = 'CUSTOM_WIDGET_BUFFER_MAKE_SMART';
export const CUSTOM_WIDGET_BUFFERS_UPDATE_SMART_RULES = 'CUSTOM_WIDGET_BUFFERS_UPDATE_SMART_RULES';
export const CUSTOM_WIDGET_EDIT_UNDO = 'CUSTOM_WIDGET_EDIT_UNDO';
export const CUSTOM_WIDGET_EDIT_REDO = 'CUSTOM_WIDGET_EDIT_REDO';
export const CUSTOM_WIDGETS_WITH_META_DATA_FETCH = 'CUSTOM_WIDGETS_WITH_META_DATA_FETCH';
export const CUSTOM_WIDGETS_MAPPING_FETCH = 'CUSTOM_WIDGETS_MAPPING_FETCH';
export const GLOBAL_GROUPS_FETCH_FOR_WIDGETS = 'GLOBAL_GROUPS_FETCH_FOR_WIDGETS';
export const GLOBAL_WIDGET_DELETE = 'GLOBAL_WIDGET_DELETE';
export const GLOBAL_WIDGET_EDIT_BODY = 'GLOBAL_WIDGET_EDIT_BODY';
export const GLOBAL_WIDGET_FETCH = 'GLOBAL_WIDGET_FETCH';
export const GLOBAL_WIDGET_PUBLISH = 'GLOBAL_WIDGET_PUBLISH';
export const GLOBAL_WIDGET_RENAME = 'GLOBAL_WIDGET_RENAME';
export const GLOBAL_WIDGET_REVERT = 'GLOBAL_WIDGET_REVERT';
export const GLOBAL_WIDGET_REVISIONS_FETCH = 'GLOBAL_WIDGET_REVISIONS_FETCH';
export const GLOBAL_WIDGETS_LIST_SUMMARIES_FETCH = 'GLOBAL_WIDGETS_LIST_SUMMARIES_FETCH';
export const GLOBAL_WIDGET_EDIT_SMART_RULES = 'GLOBAL_WIDGET_EDIT_SMART_RULES';
export const GLOBAL_WIDGET_REMOVE_SMART_RULES = 'GLOBAL_WIDGET_REMOVE_SMART_RULES';
export const GLOBAL_WIDGET_UPGRADE = 'GLOBAL_WIDGET_UPGRADE';
export const GLOBAL_WIDGET_EDIT_BODY_UNDO = 'GLOBAL_WIDGET_EDIT_BODY_UNDO';
export const GLOBAL_WIDGET_EDIT_BODY_REDO = 'GLOBAL_WIDGET_EDIT_BODY_REDO';
export const GLOBAL_WIDGET_CREATE_FROM_FILE = 'GLOBAL_WIDGET_CREATE_FROM_FILE';
export const CUSTOM_WIDGET_REVISIONS_FETCH = 'CUSTOM_WIDGET_REVISIONS_FETCH';
export const CUSTOM_WIDGET_REVISION_FETCH = 'CUSTOM_WIDGET_REVISION_FETCH';
export const LAYOUT_REVISION_FETCH = 'LAYOUT_REVISION_FETCH';
export const LAYOUT_REVISIONS_FETCH = 'LAYOUT_REVISIONS_FETCH';
export const TEMPLATE_REVISION_FETCH = 'TEMPLATE_REVISION_FETCH';
export const TEMPLATE_REVISIONS_FETCH = 'TEMPLATE_REVISIONS_FETCH';
export const RAW_ASSET_REVISION_FETCH = 'RAW_ASSET_REVISION_FETCH';
export const RAW_ASSET_REVISIONS_FETCH = 'RAW_ASSET_REVISIONS_FETCH';
export const TAB_OPEN = 'TAB_OPEN';
export const TAB_CLOSE = 'TAB_CLOSE';
export const TAB_MOVE = 'TAB_MOVE';
export const TAB_UPDATE = 'TAB_UPDATE';
export const TAB_REPLACE = 'TAB_REPLACE';
export const TOGGLE_TABS_SCROLL_INTO_VIEW = 'TOGGLE_TABS_SCROLL_INTO_VIEW';
export const TABS_FETCH = 'TABS_FETCH';
export const TABS_SAVE = 'TABS_SAVE';
export const TABS_CLEAR = 'TABS_CLEAR';
export const TABS_CLOSE = 'TABS_CLOSE';
export const TAB_REDIRECT_ADD = 'TAB_REDIRECT_ADD';
export const TABS_REDIRECTS_CLEAR = 'TABS_REDIRECTS_CLEAR';
export const LAYOUT_DND_UPDATE_CONTEXT_MONITOR = 'LAYOUT_DND_UPDATE_CONTEXT_MONITOR';
export const LAYOUT_DND_MOVE_WIDGET_WITHIN_ROW = 'LAYOUT_DND_MOVE_WIDGET_WITHIN_ROW';
export const LAYOUT_DND_MOVE_WIDGET_TO_NEW_ROW = 'LAYOUT_DND_MOVE_WIDGET_TO_NEW_ROW';
export const LAYOUT_DND_MOVE_WIDGET_AND_CREATE_CELL = 'LAYOUT_DND_MOVE_WIDGET_AND_CREATE_CELL';
export const LAYOUT_DND_HORIZONTAL_RESIZE_WIDGETS = 'LAYOUT_DND_HORIZONTAL_RESIZE_WIDGETS';
export const LAYOUT_DND_INSERT_SIDEBAR_WIDGET_IN_ROW = 'LAYOUT_DND_INSERT_SIDEBAR_WIDGET_IN_ROW';
export const LAYOUT_DND_INSERT_SIDEBAR_WIDGET_AND_CREATE_CELL = 'LAYOUT_DND_INSERT_SIDEBAR_WIDGET_AND_CREATE_CELL';
export const LAYOUT_DND_MOVE_SIDEBAR_WIDGET_AND_CREATE_ROW = 'LAYOUT_DND_MOVE_SIDEBAR_WIDGET_AND_CREATE_ROW';
export const LAYOUT_DND_MOVE_ROW = 'LAYOUT_DND_MOVE_ROW';
export const LAYOUT_DND_MOVE_WIDGET_AND_CREATE_ROW = 'LAYOUT_DND_MOVE_WIDGET_AND_CREATE_ROW';
export const LAYOUT_EDIT_UNDO = 'LAYOUT_EDIT_UNDO';
export const LAYOUT_EDIT_REDO = 'LAYOUT_EDIT_REDO';
export const LAYOUT_WIDGET_DELETE = 'LAYOUT_WIDGET_DELETE';
export const LAYOUT_WIDGET_DELETE_CONFIRM = 'LAYOUT_WIDGET_DELETE_CONFIRM';
export const LAYOUT_WIDGET_DELETE_REVERT = 'LAYOUT_WIDGET_DELETE_REVERT';
export const LAYOUT_WIDGET_GROUP_TYPE_TRANSFORM = 'LAYOUT_WIDGET_GROUP_TYPE_TRANSFORM';
export const LAYOUT_WIDGET_GROUP_TYPE_TRANSFORM_CONFIRM = 'LAYOUT_WIDGET_GROUP_TYPE_TRANSFORM_CONFIRM';
export const LAYOUT_WIDGET_GROUP_TYPE_TRANSFORM_REVERT = 'LAYOUT_WIDGET_GROUP_TYPE_TRANSFORM_REVERT';
export const LAYOUT_WIDGET_EDIT = 'LAYOUT_WIDGET_EDIT';
export const LAYOUT_WIDGET_EDIT_PARAMS = 'LAYOUT_WIDGET_EDIT_PARAMS';
export const LAYOUT_WIDGET_EDIT_LANGUAGE_OVERRIDES = 'LAYOUT_WIDGET_EDIT_LANGUAGE_OVERRIDES';
export const LAYOUT_WIDGET_EDIT_CUSTOM_WIDGET = 'LAYOUT_WIDGET_EDIT_CUSTOM_WIDGET';
export const LAYOUT_WIDGET_EDIT_GLOBAL_WIDGET = 'LAYOUT_WIDGET_EDIT_GLOBAL_WIDGET';
export const LAYOUT_WIDGET_MAKE_GLOBAL = 'LAYOUT_WIDGET_MAKE_GLOBAL';
export const LAYOUT_WIDGET_MAKE_CMV2_GLOBAL = 'LAYOUT_WIDGET_MAKE_CMV2_GLOBAL';
export const LAYOUT_WIDGET_MAKE_LOCAL_COPY_GLOBAL_WIDGET = 'LAYOUT_WIDGET_MAKE_LOCAL_COPY_GLOBAL_WIDGET';
export const LAYOUT_WIDGET_MAKE_LOCAL_COPY_CMV2_GLOBAL_WIDGET = 'LAYOUT_WIDGET_MAKE_LOCAL_COPY_CMV2_GLOBAL_WIDGET';
export const LAYOUT_WIDGET_MAKE_LOCAL_COPY_GLOBAL_GROUP = 'LAYOUT_WIDGET_MAKE_LOCAL_COPY_GLOBAL_GROUP';
export const LAYOUT_WIDGET_RESTORE_PARENT = 'LAYOUT_WIDGET_RESTORE_PARENT';
export const LAYOUT_WIDGET_SWAP = 'LAYOUT_WIDGET_SWAP';
export const LAYOUT_WIDGET_ADD_WIDGET_BELOW = 'LAYOUT_WIDGET_ADD_WIDGET_BELOW';
export const LAYOUT_WIDGET_EDIT_SMART_RULES = 'LAYOUT_WIDGET_EDIT_SMART_RULES';
export const LAYOUT_WIDGET_REMOVE_SMART_RULES = 'LAYOUT_WIDGET_REMOVE_SMART_RULES';
export const LAYOUT_WIDGET_UPDATE_SMART_RULES = 'LAYOUT_WIDGET_UPDATE_SMART_RULES';
export const LAYOUT_WIDGET_CLONE = 'LAYOUT_WIDGET_CLONE';
export const LAYOUT_WIDGET_CSS_CLASSES_STRIP_DUPLICATES = 'LAYOUT_WIDGET_CSS_CLASSES_STRIP_DUPLICATES';
export const LAYOUT_MULTI_WIDGET_EDIT_CSS_CLASSES = 'LAYOUT_MULTI_WIDGET_EDIT_CSS_CLASSES';
export const LAYOUT_CELL_EDIT_GLOBAL_GROUP = 'LAYOUT_CELL_EDIT_GLOBAL_GROUP';
export const LAYOUT_CELL_MAKE_GLOBAL = 'LAYOUT_CELL_MAKE_GLOBAL';
export const LAYOUT_CELL_UNGROUP = 'LAYOUT_CELL_UNGROUP';
export const LAYOUT_GROUPING_TOGGLE = 'LAYOUT_GROUPING_TOGGLE';
export const LAYOUT_GROUPING_CREATE = 'LAYOUT_GROUPING_CREATE';
export const LAYOUT_GROUPING_TOGGLE_WIDGET = 'LAYOUT_GROUPING_TOGGLE_WIDGET';
export const LAYOUT_GROUPING_VALIDATED = 'LAYOUT_GROUPING_VALIDATED';
export const LAYOUT_GROUPING_REMOVE = 'LAYOUT_GROUPING_REMOVE';
export const LAYOUT_LOCALIZATION_DELETE_LANGUAGE = 'LAYOUT_LOCALIZATION_DELETE_LANGUAGE';
export const LAYOUT_LOCALIZATION_CHANGE_MASTER_LANGUAGE = 'LAYOUT_LOCALIZATION_CHANGE_MASTER_LANGUAGE';
export const LAYOUT_LOCALIZATION_OPT_IN = 'LAYOUT_LOCALIZATION_OPT_IN';
export const LAYOUT_LOCALIZATION_ADD_LANGUAGE = 'LAYOUT_LOCALIZATION_ADD_LANGUAGE';
export const LAYOUT_EDITOR_SESSION_REVISION_ACTIVATE = 'LAYOUT_EDITOR_SESSION_REVISION_ACTIVATE';
export const LAYOUT_EDITOR_SESSION_REVISION_DEACTIVATE = 'LAYOUT_EDITOR_SESSION_REVISION_DEACTIVATE';
export const LAYOUT_EDITOR_SESSION_TOGGLE_WIDGET_SELECTION = 'LAYOUT_EDITOR_SESSION_TOGGLE_WIDGET_SELECTION';
export const LAYOUT_EDITOR_SESSION_ADD_WIDGET_SELECTION = 'LAYOUT_EDITOR_SESSION_ADD_WIDGET_SELECTION';
export const LAYOUT_EDITOR_SESSION_REMOVE_WIDGET_SELECTION = 'LAYOUT_EDITOR_SESSION_REMOVE_WIDGET_SELECTION';
export const LAYOUT_EDITOR_SESSION_SET_WIDGET_SELECTIONS = 'LAYOUT_EDITOR_SESSION_SET_WIDGET_SELECTIONS';
export const LAYOUT_EDITOR_SESSION_CLEAR_WIDGET_SELECTIONS = 'LAYOUT_EDITOR_SESSION_CLEAR_WIDGET_SELECTIONS';
export const LAYOUT_EDITOR_SESSION_SCROLL_TO_WIDGET_SELECTIONS = 'LAYOUT_EDITOR_SESSION_SCROLL_TO_WIDGET_SELECTIONS';
export const LAYOUT_EDITOR_SESSION_WIDGET_CONTENT_EDITOR_OPEN = 'LAYOUT_EDITOR_SESSION_WIDGET_CONTENT_EDITOR_OPEN';
export const LAYOUT_EDITOR_SESSION_WIDGET_CONTENT_EDITOR_CLOSE = 'LAYOUT_EDITOR_SESSION_WIDGET_CONTENT_EDITOR_CLOSE';
export const LAYOUT_EDITOR_SESSION_FULL_SCREEN_CODE_EDITOR_OPEN = 'LAYOUT_EDITOR_SESSION_FULL_SCREEN_CODE_EDITOR_OPEN';
export const LAYOUT_EDITOR_SESSION_FULL_SCREEN_CODE_EDITOR_CLOSE = 'LAYOUT_EDITOR_SESSION_FULL_SCREEN_CODE_EDITOR_CLOSE';
export const LAYOUT_EDITOR_SESSION_WIDGET_SELECT_SMART_RULE = 'LAYOUT_EDITOR_SESSION_WIDGET_SELECT_SMART_RULE';
export const LAYOUT_EDITOR_SESSION_BLOG_CONTENT_MODULE_EDITOR_OPEN = 'LAYOUT_EDITOR_SESSION_BLOG_CONTENT_MODULE_EDITOR_OPEN';
export const LAYOUT_EDITOR_SESSION_BLOG_CONTENT_MODULE_EDITOR_CLOSE = 'LAYOUT_EDITOR_SESSION_BLOG_CONTENT_MODULE_EDITOR_CLOSE';
export const LAYOUT_EDITOR_SESSION_HEAD_BODY_EDITOR_OPEN = 'LAYOUT_EDITOR_SESSION_HEAD_BODY_EDITOR_OPEN';
export const LAYOUT_EDITOR_SESSION_HEAD_BODY_EDITOR_CLOSE = 'LAYOUT_EDITOR_SESSION_HEAD_BODY_EDITOR_CLOSE';
export const LAYOUT_EDITOR_SESSION_SET_EDITING_LANGUAGE = 'LAYOUT_EDITOR_SESSION_SET_EDITING_LANGUAGE';
export const LAYOUT_EDITOR_SESSION_SET_EDITOR_MODE = 'LAYOUT_EDITOR_SESSION_SET_EDITOR_MODE';
export const LAYOUT_WIDGET_ADD_SMART_RULE = 'LAYOUT_WIDGET_ADD_SMART_RULE';
export const LAYOUT_WIDGET_EDIT_SMART_RULE = 'LAYOUT_WIDGET_EDIT_SMART_RULE';
export const LAYOUT_WIDGET_REMOVE_SMART_RULE = 'LAYOUT_WIDGET_REMOVE_SMART_RULE';
export const LAYOUT_WIDGET_EDIT_SMART_RULES_ORDER = 'LAYOUT_WIDGET_EDIT_SMART_RULES_ORDER';
export const WIDGET_CATALOG_CATEGORY_FILTER = 'WIDGET_CATALOG_CATEGORY_FILTER';
export const COS_INDEX_CONNECTIONS_FETCH_PARENTS = 'COS_INDEX_CONNECTIONS_FETCH_PARENTS';
export const COS_INDEX_CONNECTIONS_BULK_FETCH_PARENTS = 'COS_INDEX_CONNECTIONS_BULK_FETCH_PARENTS';
export const COS_INDEX_CONNECTIONS_FETCH_FOR_LAYOUT_WIDGETS = 'COS_INDEX_CONNECTIONS_FETCH_FOR_LAYOUT_WIDGETS';
export const BLOGS_FETCH = 'BLOGS_FETCH';
export const DOMAINS_FETCH = 'DOMAINS_FETCH';
export const TEMPLATE_CREATE = 'TEMPLATE_CREATE';
export const TEMPLATE_CREATE_FROM_FILE = 'TEMPLATE_CREATE_FROM_FILE';
export const TEMPLATE_BUFFER_CLONE = 'TEMPLATE_BUFFER_CLONE';
export const TEMPLATE_BUFFER_DELETE = 'TEMPLATE_BUFFER_DELETE';
export const TEMPLATE_BUFFER_DISCARD = 'TEMPLATE_BUFFER_DISCARD';
export const TEMPLATE_BUFFER_FETCH = 'TEMPLATE_BUFFER_FETCH';
export const TEMPLATE_BUFFER_FETCH_BY_PATH = 'TEMPLATE_BUFFER_FETCH_BY_PATH';
export const TEMPLATE_BUFFER_MOVE_RENAME = 'TEMPLATE_BUFFER_MOVE_RENAME';
export const TEMPLATE_BUFFER_PUBLISH = 'TEMPLATE_BUFFER_PUBLISH';
export const TEMPLATE_BUFFER_PUBLISH_REQUEST = 'TEMPLATE_BUFFER_PUBLISH_REQUEST';
export const TEMPLATE_BUFFER_REVERT = 'TEMPLATE_BUFFER_REVERT';
export const TEMPLATE_BUFFER_SAVE = 'TEMPLATE_BUFFER_SAVE';
export const TEMPLATE_BUFFER_SAVE_REQUEST = 'TEMPLATE_BUFFER_SAVE_REQUEST';
export const TEMPLATE_BUFFER_SAVE_BY_PATH = 'TEMPLATE_BUFFER_SAVE_BY_PATH';
export const TEMPLATE_BUFFER_SAVE_BY_PATH_REQUEST = 'TEMPLATE_BUFFER_SAVE_BY_PATH_REQUEST';
export const TEMPLATE_SAVE_BY_PATH = 'TEMPLATE_SAVE_BY_PATH';
export const TEMPLATE_SAVE_BY_PATH_REQUEST = 'TEMPLATE_SAVE_BY_PATH_REQUEST';
export const TEMPLATE_BUFFER_UPDATE_SOURCE = 'TEMPLATE_BUFFER_UPDATE_SOURCE';
export const TEMPLATE_OPEN_BY_PATH = 'TEMPLATE_OPEN_BY_PATH';
export const COMPILED_HUBL_FETCH = 'COMPILED_HUBL_FETCH';
export const SITE_SETTINGS_FETCH = 'SITE_SETTINGS_FETCH';
export const LAYOUT_EDITOR_OPTIONS_FETCH = 'LAYOUT_EDITOR_OPTIONS_FETCH';
export const LAYOUT_EDITOR_OPTIONS_SAVE = 'LAYOUT_EDITOR_OPTIONS_SAVE';
export const LAYOUT_EDITOR_OPTIONS_TOGGLE_WIDGET_SIDEBAR = 'LAYOUT_EDITOR_OPTIONS_TOGGLE_WIDGET_SIDEBAR';
export const LAYOUT_EDITOR_OPTIONS_SAVE_ACCORDION_STATE = 'LAYOUT_EDITOR_OPTIONS_SAVE_ACCORDION_STATE';
export const CUSTOM_WIDGET_EDITOR_OPTIONS_FETCH = 'CUSTOM_WIDGET_EDITOR_OPTIONS_FETCH';
export const CUSTOM_WIDGET_EDITOR_OPTIONS_SAVE = 'CUSTOM_WIDGET_EDITOR_OPTIONS_SAVE';
export const CUSTOM_WIDGET_EDITOR_OPTIONS_HYDRATE = 'CUSTOM_WIDGET_EDITOR_OPTIONS_HYDRATE';
export const CUSTOM_WIDGET_EDITOR_OPTIONS_UPDATE_PANE = 'CUSTOM_WIDGET_EDITOR_OPTIONS_UPDATE_PANE';
export const CUSTOM_WIDGET_EDITOR_OPTIONS_SET_SELECTED_FIELD = 'CUSTOM_WIDGET_EDITOR_OPTIONS_SET_SELECTED_FIELD';
export const CUSTOM_WIDGET_EDITOR_OPTIONS_TOGGLE_FIELD_GROUPING = 'CUSTOM_WIDGET_EDITOR_OPTIONS_TOGGLE_FIELD_GROUPING';
export const CUSTOM_WIDGET_EDITOR_OPTIONS_TOGGLE_FIELD_GROUPING_SELECTION = 'CUSTOM_WIDGET_EDITOR_OPTIONS_TOGGLE_FIELD_GROUPING_SELECTION';
export const CUSTOM_WIDGET_EDITOR_OPTIONS_SET_IS_ICON_SELECTING = 'CUSTOM_WIDGET_EDITOR_OPTIONS_SET_IS_ICON_SELECTING';
export const CUSTOM_WIDGET_EDITOR_OPTIONS_SET_IS_EDITING_GLOBAL_CONTENT = 'CUSTOM_WIDGET_EDITOR_OPTIONS_SET_IS_EDITING_GLOBAL_CONTENT';
export const CUSTOM_WIDGET_EDITOR_OPTIONS_SET_FULL_SCREEN_EDITOR_OPEN = 'CUSTOM_WIDGET_EDITOR_OPTIONS_SET_FULL_SCREEN_EDITOR_OPEN';
export const CUSTOM_WIDGET_EDITOR_OPTIONS_SAVE_ACCORDION_STATE = 'CUSTOM_WIDGET_EDITOR_OPTIONS_SAVE_ACCORDION_STATE';
export const CUSTOM_WIDGET_EDITOR_OPTIONS_SET_LANGUAGE_EDITOR = 'CUSTOM_WIDGET_EDITOR_OPTIONS_SET_LANGUAGE_EDITOR';
export const CODE_EDITOR_TOGGLE_COMPILED_SPLIT_SCREEN = 'CODE_EDITOR_TOGGLE_COMPILED_SPLIT_SCREEN';
export const ACE_EDITOR_STATE_UPDATE = 'ACE_EDITOR_STATE_UPDATE';
export const CODEMIRROR_SESSION_FETCH = 'CODEMIRROR_SESSION_FETCH';
export const CODEMIRROR_SESSION_SAVE = 'CODEMIRROR_SESSION_SAVE';
export const CODEMIRROR_SESSION_DELETE = 'CODEMIRROR_SESSION_DELETE';
export const CODEMIRROR_SESSION_EDITOR_UPDATE = 'CODEMIRROR_SESSION_EDITOR_UPDATE';
export const CODEMIRROR_SESSION_EDITOR_REMOVE = 'CODEMIRROR_SESSION_EDITOR_REMOVE';
export const CODEMIRROR_OPTIONS_FETCH = 'CODEMIRROR_OPTIONS_FETCH';
export const CODEMIRROR_OPTIONS_UPDATE = 'CODEMIRROR_OPTIONS_UPDATE';
export const PREVIEW_OPTIONS_FETCH = 'PREVIEW_OPTIONS_FETCH';
export const PREVIEW_OPTIONS_SAVE = 'PREVIEW_OPTIONS_SAVE';
export const PREVIEW_OPTIONS_DELETE = 'PREVIEW_OPTIONS_DELETE';
export const PREVIEW_OPTIONS_UPDATE_PREVIEW_CONFIGURATION = 'PREVIEW_OPTIONS_UPDATE_PREVIEW_CONFIGURATION';
export const PREVIEW_OPTIONS_TOGGLE_PREVIEW = 'PREVIEW_OPTIONS_TOGGLE_PREVIEW';
export const PREVIEW_OPTIONS_FETCH_BUILDS = 'PREVIEW_OPTIONS_FETCH_BUILDS';
export const PREVIEW_OPTIONS_CHECK_TEMPLATE_BY_BUILD = 'PREVIEW_OPTIONS_CHECK_TEMPLATE_BY_BUILD';
export const LAYOUT_TO_CLONE_FROM_FETCH = 'LAYOUT_TO_CLONE_FROM_FETCH';
export const PORTAL_COPY_ASSET_DEPENDENCIES_FETCH = 'PORTAL_COPY_ASSET_DEPENDENCIES_FETCH';
export const PORTAL_COPY_REQUEST_SET_ACTIVE = 'PORTAL_COPY_REQUEST_SET_ACTIVE';
export const ASSETS_PORTAL_COPY_ACCESS_FETCH = 'ASSETS_PORTAL_COPY_ACCESS_FETCH';
export const ASSETS_PORTAL_COPY_ACCESS_RESET = 'ASSETS_PORTAL_COPY_ACCESS_RESET';
export const FINDER_FETCH_THEMES = 'FINDER_FETCH_THEMES';
export const FINDER_ASSET_DESELECT = 'FINDER_ASSET_DESELECT';
export const FINDER_ASSET_TOGGLE_SELECTION = 'FINDER_ASSET_TOGGLE_SELECTION';
export const FINDER_ASSET_TOGGLE_SELECTIONS = 'FINDER_ASSET_TOGGLE_SELECTIONS';
export const FINDER_ASSET_TOGGLE_RENAME = 'FINDER_ASSET_TOGGLE_RENAME';
export const FINDER_ASSETS_SEARCH_FETCH = 'FINDER_ASSETS_SEARCH_FETCH';
export const FINDER_ASSETS_SEARCH_SELECT_ASSET = 'FINDER_ASSETS_SEARCH_SELECT_ASSET';
export const FINDER_ASSET_REVEAL_IN_FINDER = 'FINDER_ASSET_REVEAL_IN_FINDER';
export const FINDER_ASSETS_PORTAL_COPY = 'FINDER_ASSETS_PORTAL_COPY';
export const FINDER_ASSETS_PORTAL_COPY_REQUEST = 'FINDER_ASSETS_PORTAL_COPY_REQUEST';
export const FINDER_ASSETS_PORTAL_COPY_RECEIVE = 'FINDER_ASSETS_PORTAL_COPY_RECEIVE';
export const FINDER_ASSETS_PORTAL_COPY_ERROR = 'FINDER_ASSETS_PORTAL_COPY_ERROR';
export const FINDER_ASSETS_PORTAL_COPY_RESET = 'FINDER_ASSETS_PORTAL_COPY_RESET';
export const FINDER_BULK_DELETE = 'FINDER_BULK_DELETE';
export const FINDER_BULK_MOVE = 'FINDER_BULK_MOVE';
export const FINDER_BULK_PORTAL_COPY = 'FINDER_BULK_PORTAL_COPY';
export const FINDER_DESELECT_ALL = 'FINDER_DESELECT_ALL';
export const FINDER_FILE_COPY_MODULE_SNIPPET = 'FINDER_FILE_COPY_MODULE_SNIPPET';
export const FINDER_FILE_COPY_PATH = 'FINDER_FILE_COPY_PATH';
export const FINDER_FILE_COPY_PUBLIC_URL = 'FINDER_FILE_COPY_PUBLIC_URL';
export const FINDER_FILE_CREATE = 'FINDER_FILE_CREATE';
export const FINDER_FILE_CREATE_EMAIL = 'FINDER_FILE_CREATE_EMAIL';
export const FINDER_FILE_CREATE_FROM_EDITOR = 'FINDER_FILE_CREATE_FROM_EDITOR';
export const FINDER_FILE_CREATE_PAGE = 'FINDER_FILE_CREATE_PAGE';
export const FINDER_FILE_DELETE = 'FINDER_FILE_DELETE';
export const FINDER_FILE_HIDE_DEPENDENTS = 'FINDER_FILE_HIDE_DEPENDENTS';
export const FINDER_FILE_SHOW_DEPENDENTS = 'FINDER_FILE_SHOW_DEPENDENTS';
export const FINDER_FILE_DUPLICATE = 'FINDER_FILE_DUPLICATE';
export const FINDER_FILE_DUPLICATE_LAYOUT_TO_TEMPLATE = 'FINDER_FILE_DUPLICATE_LAYOUT_TO_TEMPLATE';
export const FINDER_FILE_DUPLICATE_READ_ONLY = 'FINDER_FILE_DUPLICATE_READ_ONLY';
export const FINDER_FILE_RENAME = 'FINDER_FILE_RENAME';
export const FINDER_FILE_RENAME_CONFIRM_HIDE = 'FINDER_FILE_RENAME_CONFIRM_HIDE';
export const FINDER_FILE_RESTORE_DELETED = 'FINDER_FILE_RESTORE_DELETED';
export const FINDER_FILE_SHOW_INFORMATION = 'FINDER_FILE_SHOW_INFORMATION';
export const FINDER_FILE_SHOW_REVISIONS = 'FINDER_FILE_SHOW_REVISIONS';
export const FINDER_FILE_HIDE_REVISIONS = 'FINDER_FILE_HIDE_REVISIONS';
export const FINDER_FILE_UPLOAD = 'FINDER_FILE_UPLOAD';
export const FINDER_FILE_UPLOAD_FINISHED = 'FINDER_FILE_UPLOAD_FINISHED';
export const FINDER_FILE_UPLOAD_UPDATE_PROGRESS = 'FINDER_FILE_UPLOAD_UPDATE_PROGRESS';
export const FINDER_FILE_VIEW_LAYOUT_SOURCE = 'FINDER_FILE_VIEW_LAYOUT_SOURCE';
export const FINDER_FILES_BULK_DELETE = 'FINDER_FILES_BULK_DELETE';
export const FINDER_FILES_RECENTLY_DELETED_FETCH = 'FINDER_FILES_RECENTLY_DELETED_FETCH';
export const FINDER_FILES_RECENTLY_EDITED_FETCH = 'FINDER_FILES_RECENTLY_EDITED_FETCH';
export const FINDER_FILES_SEARCH_FETCH = 'FINDER_FILES_SEARCH_FETCH';
export const FINDER_FILEMAPPER_FETCH_DEFAULT = 'FINDER_FILEMAPPER_FETCH_DEFAULT';
export const FINDER_FOLDER_CONTENTS_FETCH = 'FINDER_FOLDER_CONTENTS_FETCH';
export const FINDER_FOLDER_CONTENTS_BULK_DELETE = 'FINDER_FOLDER_CONTENTS_BULK_DELETE';
export const FINDER_FOLDER_CONTENTS_MOVE = 'FINDER_FOLDER_CONTENTS_MOVE';
export const FINDER_FOLDER_COPY_PATH = 'FINDER_FOLDER_COPY_PATH';
export const FINDER_FOLDER_CREATE = 'FINDER_FOLDER_CREATE';
export const FINDER_FOLDER_DELETE = 'FINDER_FOLDER_DELETE';
export const FINDER_FOLDER_PARENTS_FETCH = 'FINDER_FOLDER_PARENTS_FETCH';
export const FINDER_FOLDER_DUPLICATE = 'FINDER_FOLDER_DUPLICATE';
export const FINDER_FOLDER_MOVE_FILE = 'FINDER_FOLDER_MOVE_FILE';
export const FINDER_FOLDER_MOVE_FOLDER = 'FINDER_FOLDER_MOVE_FOLDER';
export const FINDER_FOLDER_RENAME = 'FINDER_FOLDER_RENAME';
export const FINDER_FOLDER_RENAME_CONFIRM_HIDE = 'FINDER_FOLDER_RENAME_CONFIRM_HIDE';
export const FINDER_FOLDER_TOGGLE_OPEN = 'FINDER_FOLDER_TOGGLE_OPEN';
export const FINDER_FOLDER_TOGGLE_LOCK = 'FINDER_FOLDER_TOGGLE_LOCK';
export const FINDER_FOLDER_OPEN_DEEPLY_NESTED = 'FINDER_FOLDER_OPEN_DEEPLY_NESTED';
export const FINDER_FOLDER_OPEN_EDITOR = 'FINDER_FOLDER_OPEN_EDITOR';
export const FINDER_FOLDERS_BULK_DELETE = 'FINDER_FOLDERS_BULK_DELETE';
export const FINDER_FOLDERS_COLLAPSE_ALL = 'FINDER_FOLDERS_COLLAPSE_ALL';
export const FINDER_THEMES_CREATE = 'FINDER_THEMES_CREATE';
export const FINDER_THEMES_CREATE_REQUEST = 'FINDER_THEMES_CREATE_REQUEST';
export const FINDER_THEMES_CREATE_RECEIVE = 'FINDER_THEMES_CREATE_RECEIVE';
export const FINDER_THEMES_CREATE_ERROR = 'FINDER_THEMES_CREATE_ERROR';
export const FINDER_THEMES_CREATE_CHILD = 'FINDER_THEMES_CREATE_CHILD';
export const FINDER_THEMES_CREATE_CHILD_REQUEST = 'FINDER_THEMES_CREATE_CHILD_REQUEST';
export const FINDER_THEMES_CREATE_CHILD_RECEIVE = 'FINDER_THEMES_CREATE_CHILD_RECEIVE';
export const FINDER_THEMES_CREATE_CHILD_ERROR = 'FINDER_THEMES_CREATE_CHILD_ERROR';
export const FINDER_THEMES_CREATE_CHILD_RESET = 'FINDER_THEMES_CREATE_CHILD_RESET';
export const FINDER_THEMES_CHILD_ADD_FILE = 'FINDER_THEMES_CHILD_ADD_FILE';
export const FINDER_THEMES_CHILD_ADD_FILE_REQUEST = 'FINDER_THEMES_CHILD_ADD_FILE_REQUEST';
export const FINDER_THEMES_CHILD_ADD_FILE_RECEIVE = 'FINDER_THEMES_CHILD_ADD_FILE_RECEIVE';
export const FINDER_THEMES_CHILD_ADD_FILE_ERROR = 'FINDER_THEMES_CHILD_ADD_FILE_ERROR';
export const FINDER_ASSETS_CHILD_ADD_FILE_RESET = 'FINDER_ASSETS_CHILD_ADD_FILE_RESET';
export const FINDER_THEMES_DUPLICATE = 'FINDER_THEMES_DUPLICATE';
export const FINDER_THEMES_DUPLICATE_REQUEST = 'FINDER_THEMES_DUPLICATE_REQUEST';
export const FINDER_THEMES_DUPLICATE_RECEIVE = 'FINDER_THEMES_DUPLICATE_RECEIVE';
export const FINDER_THEMES_DUPLICATE_ERROR = 'FINDER_THEMES_DUPLICATE_ERROR';
export const FINDER_THEMES_FETCH_CHILD_THEMES = 'FINDER_THEMES_FETCH_CHILD_THEMES';
export const FINDER_THEMES_SET_ACTIVE_THEME_FOLDER_ID = 'FINDER_THEMES_SET_ACTIVE_THEME_FOLDER_ID';
export const FINDER_PROJECTS_SET_ACTIVE_PROJECT_FOLDER_ID = 'FINDER_PROJECTS_SET_ACTIVE_PROJECT_FOLDER_ID';
export const FINDER_FUNCTIONS_CREATE = 'FINDER_FUNCTIONS_CREATE';
export const FINDER_FUNCTIONS_CREATE_ENDPOINT = 'FINDER_FUNCTIONS_CREATE_ENDPOINT';
export const FINDER_FUNCTIONS_DEPLOY = 'FINDER_FUNCTIONS_DEPLOY';
export const FINDER_FUNCTIONS_DEPLOY_ERROR = 'FINDER_FUNCTIONS_DEPLOY_ERROR';
export const FINDER_FUNCTIONS_DEPLOY_REQUEST = 'FINDER_FUNCTIONS_DEPLOY_REQUEST';
export const FINDER_FUNCTIONS_DEPLOY_RECEIVE = 'FINDER_FUNCTIONS_DEPLOY_RECEIVE';
export const FINDER_FUNCTIONS_CLEAR_DEPLOY_LOGS = 'FINDER_FUNCTIONS_CLEAR_DEPLOY_LOGS';
export const FINDER_PROJECTS_CREATE = 'FINDER_PROJECTS_CREATE';
export const FINDER_PROJECTS_CREATE_REQUEST = 'FINDER_PROJECTS_CREATE_REQUEST';
export const FINDER_PROJECTS_CREATE_RECEIVE = 'FINDER_PROJECTS_CREATE_RECEIVE';
export const FINDER_PROJECTS_CREATE_ERROR = 'FINDER_PROJECTS_CREATE_ERROR';
export const FINDER_PROJECTS_DEPLOY = 'FINDER_PROJECTS_DEPLOY';
export const FINDER_PROJECTS_DEPLOY_REQUEST = 'FINDER_PROJECTS_DEPLOY_REQUEST';
export const FINDER_PROJECTS_DEPLOY_RECEIVE = 'FINDER_PROJECTS_DEPLOY_RECEIVE';
export const FINDER_PROJECTS_DEPLOY_ERROR = 'FINDER_PROJECTS_DEPLOY_ERROR';
export const FINDER_CREATE_RAW_ASSET = 'FINDER_CREATE_RAW_ASSET';
export const FINDER_OPEN_FOLDERS_FETCH = 'FINDER_OPEN_FOLDERS_FETCH';
export const FINDER_OPEN_FOLDERS_SAVE = 'FINDER_OPEN_FOLDERS_SAVE';
export const FINDER_OPEN_ACTION_MODAL = 'FINDER_OPEN_ACTION_MODAL';
export const FINDER_CLOSE_ACTION_MODAL = 'FINDER_CLOSE_ACTION_MODAL';
export const FINDER_OPTIONS_FETCH = 'FINDER_OPTIONS_FETCH';
export const FINDER_OPTIONS_SAVE = 'FINDER_OPTIONS_SAVE';
export const FINDER_ROOT_FOLDER_CONTENTS_FETCH = 'FINDER_ROOT_FOLDER_CONTENTS_FETCH';
export const FINDER_SHOW_RECENTLY_EDITED = 'FINDER_SHOW_RECENTLY_EDITED';
export const FINDER_SHOW_RECENTLY_DELETED = 'FINDER_SHOW_RECENTLY_DELETED';
export const APP_NOTIFICATION = 'APP_NOTIFICATION';
export const ONBOARDING_DATA_FETCH = 'ONBOARDING_DATA_FETCH';
export const ONBOARDING_DATA_POST = 'ONBOARDING_DATA_POST';
export const EDITOR_ERRORS_SET = 'EDITOR_ERRORS_SET';
export const EDITOR_ERRORS_ADD = 'EDITOR_ERRORS_ADD';
export const EDITOR_ERRORS_CLEAR = 'EDITOR_ERRORS_CLEAR';
export const EDITOR_ERRORS_CLEAR_ALL = 'EDITOR_ERRORS_CLEAR_ALL';
export const EDITOR_ERRORS_HUBL_SET = 'EDITOR_ERRORS_HUBL_SET';
export const EDITOR_ERRORS_HUBL_CLEAR = 'EDITOR_ERRORS_HUBL_CLEAR';
export const EDITOR_ERRORS_HUBL_CLEAR_ALL = 'EDITOR_ERRORS_HUBL_CLEAR_ALL';
export const EDITOR_ERRORS_CSS_SET = 'EDITOR_ERRORS_CSS_SET';
export const EDITOR_ERRORS_CSS_CLEAR = 'EDITOR_ERRORS_CSS_CLEAR';
export const EDITOR_ERRORS_CSS_CLEAR_ALL = 'EDITOR_ERRORS_CSS_CLEAR_ALL';
export const EDITOR_ERRORS_JS_SET = 'EDITOR_ERRORS_JS_SET';
export const EDITOR_ERRORS_JS_CLEAR = 'EDITOR_ERRORS_JS_CLEAR';
export const EDITOR_ERRORS_JS_CLEAR_ALL = 'EDITOR_ERRORS_JS_CLEAR_ALL';
export const VALIDATE_TEMPLATE = 'VALIDATE_TEMPLATE';
export const VALIDATE_LAYOUT = 'VALIDATE_LAYOUT';
export const HUBL_DOCS_FETCH = 'HUBL_DOCS_FETCH';
export const SFDC_GET_INTEGRATION_STATUS = 'SFDC_GET_INTEGRATION_STATUS';
export const I18N_FETCH = 'I18N_FETCH';
export const LANGUAGES_FETCH = 'LANGUAGES_FETCH';
export const PREVIEW_OPTIONS_SAVE_PREVIEW_WINDOW = 'PREVIEW_OPTIONS_SAVE_PREVIEW_WINDOW';
export const REGISTER_STATUS_BAR = 'REGISTER_STATUS_BAR';
export const DESIGN_COMPONENTS_CODE_ACCORDION_UPDATE = 'DESIGN_COMPONENTS_CODE_ACCORDION_UPDATE';
export const RAW_ASSET_EDITOR_OPTIONS_SAVE_ACCORDION_STATE = 'RAW_ASSET_EDITOR_OPTIONS_SAVE_ACCORDION_STATE';
export const RAW_ASSET_FETCH_HAS_BUFFERED_CHANGES = 'RAW_ASSET_FETCH_HAS_BUFFERED_CHANGES';
export const RAW_ASSET_CREATE = 'RAW_ASSET_CREATE';
export const RAW_ASSET_PUBLISH = 'RAW_ASSET_PUBLISH';
export const RAW_ASSET_SAVE_BY_PATH = 'RAW_ASSET_SAVE_BY_PATH';
export const RAW_ASSET_REVERT = 'RAW_ASSET_REVERT';
export const RAW_ASSET_UPDATE_UPLOAD_PROGRESS = 'RAW_ASSET_UPDATE_UPLOAD_PROGRESS';
export const RAW_ASSET_BUFFER_REPLACE = 'RAW_ASSET_BUFFER_REPLACE';
export const RAW_ASSET_BUFFER_FETCH = 'RAW_ASSET_BUFFER_FETCH';
export const RAW_ASSET_BUFFER_FETCH_BY_PATH = 'RAW_ASSET_BUFFER_FETCH_BY_PATH';
export const RAW_ASSET_BUFFER_SAVE = 'RAW_ASSET_BUFFER_SAVE';
export const RAW_ASSET_BUFFER_SAVE_BY_PATH = 'RAW_ASSET_BUFFER_SAVE_BY_PATH';
export const RAW_ASSET_BUFFER_UPDATE_SOURCE = 'RAW_ASSET_BUFFER_UPDATE_SOURCE';
export const RAW_ASSET_BUFFER_JSON_LINT = 'RAW_ASSET_BUFFER_JSON_LINT';
export const CRM_OBJECTS_FETCH_OBJECT_TYPES = 'CRM_OBJECTS_FETCH_OBJECT_TYPES';
export const CRM_OBJECTS_FETCH_OBJECT_SCHEMA = 'CRM_OBJECTS_FETCH_OBJECT_SCHEMA';
export const PROJECTS_STAGED_FILES_RECEIVE = 'PROJECTS_STAGED_FILES_RECEIVE';
export const ECOSYSTEM_MARKETPLACE_OFFERINGS_RECEIVE = 'ECOSYSTEM_MARKETPLACE_OFFERINGS_RECEIVE';
export const HISTORY_METHOD_CALLED = 'HISTORY_METHOD_CALLED';
export const CUSTOM_FONTS_FETCH_FONTS = 'CUSTOM_FONTS_FETCH_FONTS';
/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking

if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}